import { render, staticRenderFns } from "./agv-ri-payment-methods.vue?vue&type=template&id=780bd1de&scoped=true&lang=pug&"
import script from "./agv-ri-payment-methods.vue?vue&type=script&lang=js&"
export * from "./agv-ri-payment-methods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780bd1de",
  null
  
)

export default component.exports